// extracted by mini-css-extract-plugin
var _1 = "Ly1ZE";
var _2 = "xGN8w";
var _3 = "iD5R8";
var _4 = "qwVLI";
var _5 = "QyySM";
var _6 = "OVIE8";
var _7 = "qQbyL";
var _8 = "ayhPn";
var _9 = "zjEPs";
var _a = "WKi7w";
var _b = "rY50O";
var _c = "slWCo";
var _d = "d6NfH";
var _e = "LgEnB";
var _f = "VlDxL";
var _10 = "KkZZ2";
var _11 = "ou4TM";
var _12 = "DPg26";
var _13 = "XcxaR";
var _14 = "oSXUx";
var _15 = "bn_Zl";
var _16 = "sQ56h";
var _17 = "YDRJR";
var _18 = "ZY9gP";
var _19 = "aAzXR";
var _1a = "fUFqW";
var _1b = "JIIBc";
var _1c = "ampnm";
var _1d = "Zydqd";
var _1e = "cGpRC";
export { _1 as "actionButtonClearance", _2 as "collapsePaneButton", _3 as "collapsePaneButtonContainer", _4 as "collapsePaneChevron", _5 as "compact", _6 as "container", _7 as "containerPadding", _8 as "containerPadding_Win32Style", _9 as "containerWillChangeScrollPosition", _a as "contentsContainer", _b as "dropContainer", _c as "droppableContainer", _d as "favoritesContainer", _e as "favoritesResizableContainer", _f as "favoritesResizeHandle", _10 as "foldersContainer", _11 as "isChromium", _12 as "leftNavSectionWithSectionHeaders", _13 as "medium", _14 as "myOutlookPinnedContainer", _15 as "safariScrollHandling", _16 as "scrollContainer", _17 as "touchMode", _18 as "transientCollapsePaneButtonContainer", _19 as "transientContentsContainer", _1a as "transientFavoritesContainer", _1b as "transientFolderPaneDroppable", _1c as "transientFolderPaneRoot", _1d as "transientFolderPaneRootWithButtonInset", _1e as "transientFoldersContainer" }
